var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import FormContext from './private/utils/FormContext';
import ItemContext from './private/utils/ItemContext';
import useFormContext from './private/utils/useFormContext';
import mergeClassnames from '../mergeClassnames/mergeClassnames';
const FormRoot = forwardRef((_a, ref) => {
    var { children, size = 'md', className, onSubmit } = _a, rest = __rest(_a, ["children", "size", "className", "onSubmit"]);
    const state = {
        size: size,
    };
    return (React.createElement(FormContext.Provider, { value: state },
        React.createElement("form", Object.assign({}, rest, { className: mergeClassnames(className), onSubmit: onSubmit, ref: ref }), children)));
});
const Item = ({ children, size, disabled, error, className, }) => {
    const { size: formSize } = useFormContext('Form.Item');
    const state = {
        size: size || formSize,
        disabled: disabled,
        error: error,
    };
    return (React.createElement(ItemContext.Provider, { value: state },
        React.createElement("div", { className: mergeClassnames('w-full max-w-full relative z-0', disabled && 'opacity-60 cursor-not-allowed', className && className) }, children)));
};
const Form = Object.assign(FormRoot, { Item });
export default Form;
